import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import _ from 'lodash';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox } from '../../../components/Box';
import { Button } from '../../../components/Buttons';
import { Card } from '../../../components/Card';
import { List } from '../../../components/List';
import { fetchPermissions, setUserProperty } from '../actions';
import { selectAllPermissions } from '../selectors';
import { selectUserId, selectWork } from '../../Api/selectors';
import { Checkbox } from '../../../components/Checkbox';
import { fetchKanbanBoards } from '../../KanbanBoards/actions';
import { selectKanbanBoards } from '../../KanbanBoards/selectors';
import { REQUEST_KANBAN_BOARDS } from '../../KanbanBoards/constants';
import { Loader } from '../../../components/Loader';

const Container = styled.div`
  font-size: 14px;

  .cell:first-child {
    text-transform: capitalize;
  }
`;

const STATE = {
  permissions: {},
  kanbanPermissions: [],
};
/* eslint-disable react/prefer-stateless-function */
class UserKanbanPermissionsCardComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {
    this.props.getAllKanbanBoards();
    this.props.user?.kanbanPermissions &&
      this.setState({
        kanbanPermissions: JSON.parse(this.props.user?.kanbanPermissions),
      });
  }

  reset() {
    this.setState({ ...STATE });
  }

  setPermission = p => {
    const permission = this.state.kanbanPermissions?.find(permission => p?.name === permission?.name);

    if (permission?.name) {
      const updatedPermissions = this.state.kanbanPermissions?.filter(permission => p?.name !== permission?.name);
      this.setState({ kanbanPermissions: updatedPermissions });
      return;
    }

    this.setState(prev => ({ kanbanPermissions: [...prev?.kanbanPermissions, p] }));
  };

  handleUpdate = () => {
    const permissionsArray = JSON.stringify(this.state?.kanbanPermissions);
    this.props.updatePermissions(this.props.user.id, permissionsArray);
  };

  renderPermission = p => {
    const boardPermission = {
      name: p?.label?.toLowerCase()?.replaceAll(' ', '_'),
      label: p?.label,
    };
    const isChecked = !!this.state.kanbanPermissions?.find(p => p?.name === boardPermission?.name) ? 1 : 0;
    return (
      <HBox vCenter left style={{ gap: 10 }}>
        <Checkbox checked={isChecked} onChange={() => this.setPermission(boardPermission)} />
        <span>{p?.label}</span>
      </HBox>
    );
  };

  handleCheckAll = checkAll => {
    if (checkAll) {
      const allPermissions = this.props.boards?.map(b => {
        return {
          name: b?.label?.toLowerCase()?.replaceAll(' ', '_'),
          label: b?.label,
        };
      });
      this.setState({ kanbanPermissions: allPermissions });
      return;
    }
    this.setState({ kanbanPermissions: [] });
  };

  render() {
    const { user } = this.props;
    if (this.props.work) return <Loader small />;
    return (
      <Card className="user-info-card info-card data">
        <Container>
          <h2>{this.lbl('user.details.permissions')}</h2>
          <HBox gap={'8'}>
            <Button onClick={() => this.handleCheckAll(true)}>Check All</Button>
            <Button onClick={() => this.handleCheckAll(false)}>Uncheck All</Button>
          </HBox>
          <List>{this.props.boards?.map(p => this.renderPermission(p))}</List>
          <HBox center vCenter>
            <Button onClick={this.handleUpdate}>Update</Button>
          </HBox>
        </Container>
      </Card>
    );
  }
}

UserKanbanPermissionsCardComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
  user: PropTypes.object,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    allPermissions: selectAllPermissions(),
    boards: selectKanbanBoards(),
    work: selectWork(REQUEST_KANBAN_BOARDS),
    myId: selectUserId(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    getAllPermissions: () => {
      dispatch(fetchPermissions());
    },
    getAllKanbanBoards() {
      dispatch(fetchKanbanBoards());
    },
    updatePermissions: (userId, permissions) => {
      dispatch(setUserProperty(userId, 'kanbanPermissions', permissions));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const UserKanbanPermissionsCard = compose(withConnect, withRouter)(UserKanbanPermissionsCardComp);
